import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordinalNumber',
})
export class OrdinalNumberPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    if (!value) {
      return '';
    }

    if (value > 3 && value < 21) {
      return value.toString() + 'th';
    }

    switch (value % 10) {
      case 1:
        return value.toString() + 'st';
      case 2:
        return value.toString() + 'nd';
      case 3:
        return value.toString() + 'rd';
      default:
        return value.toString() + 'th';
    }
  }
}
